var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.236,29.764H31.764c-1.104,0-2,0.896-2,2v32.473c0,1.104,0.896,2,2,2h32.473c1.104,0,2-0.896,2-2V31.764 C66.236,30.659,65.341,29.764,64.236,29.764z M62.236,62.236H33.764V33.764h28.473V62.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.539,58.462h16.923c1.104,0,2-0.896,2-2V39.539c0-1.104-0.896-2-2-2H39.539c-1.104,0-2,0.896-2,2v16.923 C37.539,57.566,38.434,58.462,39.539,58.462z M41.539,41.539h12.923v12.923H41.539V41.539z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.651,28.904c1.104,0,2-0.896,2-2v-4.195c0-1.104-0.896-2-2-2s-2,0.896-2,2v4.195 C33.651,28.009,34.547,28.904,35.651,28.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.826,28.904c1.104,0,2-0.896,2-2v-4.195c0-1.104-0.896-2-2-2s-2,0.896-2,2v4.195 C39.826,28.009,40.721,28.904,41.826,28.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.175,28.904c1.104,0,2-0.896,2-2v-4.195c0-1.104-0.896-2-2-2s-2,0.896-2,2v4.195 C52.175,28.009,53.07,28.904,54.175,28.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.349,28.904c1.104,0,2-0.896,2-2v-4.195c0-1.104-0.896-2-2-2s-2,0.896-2,2v4.195 C58.349,28.009,59.244,28.904,60.349,28.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,28.904c1.104,0,2-0.896,2-2v-4.195c0-1.104-0.896-2-2-2s-2,0.896-2,2v4.195C46,28.009,46.896,28.904,48,28.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.651,67.096c-1.104,0-2,0.896-2,2v4.195c0,1.104,0.896,2,2,2s2-0.896,2-2v-4.195 C37.651,67.991,36.756,67.096,35.651,67.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.349,67.096c-1.104,0-2,0.896-2,2v4.195c0,1.104,0.896,2,2,2s2-0.896,2-2v-4.195 C62.349,67.991,61.453,67.096,60.349,67.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,67.096c-1.104,0-2,0.896-2,2v4.195c0,1.104,0.896,2,2,2s2-0.896,2-2v-4.195C50,67.991,49.104,67.096,48,67.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.826,67.096c-1.104,0-2,0.896-2,2v4.195c0,1.104,0.896,2,2,2s2-0.896,2-2v-4.195 C43.826,67.991,42.93,67.096,41.826,67.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.175,67.096c-1.104,0-2,0.896-2,2v4.195c0,1.104,0.896,2,2,2s2-0.896,2-2v-4.195 C56.175,67.991,55.279,67.096,54.175,67.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.904,52.175h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S28.009,52.175,26.904,52.175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.904,58.349h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S28.009,58.349,26.904,58.349z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.904,39.826h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S28.009,39.826,26.904,39.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.904,46h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S28.009,46,26.904,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.904,33.651h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S28.009,33.651,26.904,33.651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.291,39.826h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S74.396,39.826,73.291,39.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.096,37.651h4.195c1.104,0,2-0.896,2-2s-0.896-2-2-2h-4.195c-1.104,0-2,0.896-2,2S67.991,37.651,69.096,37.651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.291,46h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S74.396,46,73.291,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.291,58.349h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S74.396,58.349,73.291,58.349z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.291,52.175h-4.195c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.195c1.104,0,2-0.896,2-2S74.396,52.175,73.291,52.175z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.4bf11ca9812f456d21cf8dcbc8452b6a.svg";
export { ForwardRef as ReactComponent };